export default "__VITE_ASSET__Di18yCZX__"